import {
  Box,
  Button,
  Card,
  Loader,
  MarketingPageLayout,
  MarketingPageLayoutContent,
  Page,
  WixDesignSystemProvider,
  Image,
} from "@wix/design-system";
import "@wix/design-system/styles.global.css";
import React, { useEffect } from "react";
import HeroImage from "./hero.png";
import { ReactTagManager } from "react-gtm-ts";
import * as Icons from "@wix/wix-ui-icons-common";
import { useTranslation } from "react-i18next";
import { identify, track, WIX_APP_ID } from "./analytics";

const tagManagerArgs = {
  code: "GTM-WZQPMC7",
};

const BASE_URL = "https://wix.certifiedcode.io/tiktok-embed/_functions";

function App() {
  const { t } = useTranslation();
  const [isUpgraded, setIsUpgraded] = React.useState(false);
  const token = new URLSearchParams(window.location.search).get("token");
  const instance = new URLSearchParams(window.location.search).get("instance");

  useEffect(() => {
    ReactTagManager.init(tagManagerArgs);
  }, []);

  useEffect(() => {
    identify(instance);
    track("dashboard_opened", { has_token: Boolean(token) });
    loadInstance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance, token]);

  function loadInstance() {
    fetch(BASE_URL + "/@certifiedcode/base-backend/instance", {
      method: "GET",
      headers: { Authorization: instance || "" },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsUpgraded(data?.instance?.isFree === false);
      })
      .catch(() => {});
  }

  const upgradeUrl = `https://memberships.certifiedcode.us/${window.location.search}`;

  if (token) {
    track("install_redirect");
    window.location.href = `https://www.wix.com/installer/install?token=${token}&appId=${WIX_APP_ID}&redirectUrl=https://wix.certifiedcode.io/tiktok-embed/_functions/@certifiedcode/base-backend/auth`;
    return (
      <WixDesignSystemProvider features={{ newColorsBranding: true }}>
        <Page height="100vh">
          <Page.Content>
            <Box height={"90vh"} direction="vertical" verticalAlign="middle">
              <Loader text={t("loading")} />
            </Box>
          </Page.Content>
        </Page>
      </WixDesignSystemProvider>
    );
  }

  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <Card>
        <MarketingPageLayout
          removeImageHorizontalPadding
          removeImageVerticalPadding
          content={
            <Box height="840px" verticalAlign="middle">
              <MarketingPageLayoutContent
                title={t("tiktok-title")}
                content={t("tiktok-content")}
                actions={
                  <Box direction="vertical" gap="SP2">
                    <Button
                      prefixIcon={<Icons.PremiumFilled />}
                      skin={isUpgraded ? "premium-light" : "premium"}
                      as="a"
                      href={upgradeUrl}
                      target="_blank"
                      onClick={() => track("upgrade_clicked")}
                    >
                      {isUpgraded ? t("manage-plan") : t("upgrade")}
                    </Button>
                    <Button
                      priority="secondary"
                      prefixIcon={<Icons.GetStarted />}
                      onClick={() => {
                        track("setup_guide_clicked");
                        window.Intercom("showArticle", 8678985);
                      }}
                    >
                      {t("setup_guide")}
                    </Button>
                    <Button
                      prefixIcon={<Icons.Reviews />}
                      skin="inverted"
                      as="a"
                      href={`https://bridget.reviews.certifiedcode.us/${WIX_APP_ID}${window.location.search}`}
                      target="_blank"
                      onClick={() => track("write_review_clicked")}
                    >
                      {t("tiktok-review-button")}
                    </Button>
                  </Box>
                }
              />
            </Box>
          }
          image={<Image borderRadius={0} src={HeroImage} />}
        />
      </Card>
    </WixDesignSystemProvider>
  );
}

export default App;
